import React, { useEffect, useRef } from 'react';
import MapView from '../MapView/MapView';
import UserHeader from '../Headers/UserHeader';
import {NavLink,useHistory, Redirect,withRouter} from 'react-router-dom';
 
//Start UsersDashboard component code ...
const UsersDashboard = (props) => { 
    const [login, setLogin] = React.useState(false);
    const [clicked, setClicked] = React.useState(true);
    useEffect(
        () => {
            if(props.location.state) {
                setClicked(props.location.state);
                setLogin(props.location.state.newLogin);
            }           
        },[props])
    return <>
    {/* <UserHeader/>         */}
  <MapView newLogin = {login} clicked = {clicked}/>  
    </>   

}

export default withRouter(UsersDashboard)
//Start UsersDashboard component code ...
